import { render, staticRenderFns } from "./PricingCreate.vue?vue&type=template&id=4d72e12d"
import script from "./PricingCreate.vue?vue&type=script&lang=js"
export * from "./PricingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports